var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,attrs:{"id":"app-layout"}},[_c('side-nav'),_c('div',{staticClass:"app-content"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('hr'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }